import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-0.5 opacity-100", _ctx.contrast ? 'bg-white' : 'bg-black']),
    style: _normalizeStyle(_ctx.percentageCount)
  }, null, 6))
}